module.exports = __webpack_public_path__ + "img/violet_133.da14ec7a.png";